// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import Hr from "elevate-ui/Hr";
import { withGlobalContext } from "../common/GlobalContext";

import type { $Agent, $SiteOffice } from "flow/types";

type $Props = {
  agent: $Agent,
  classes: Object,
  office: $SiteOffice,
};

const Agentology = ({ classes, agent, office }: $Props) => {
  const email =
    agent && agent.email
      ? agent.email
      : office && office.email
        ? office.email
        : "";

  return (
    <div className={classes.root}>
      <Typography type="heading2" gutterTop gutterBottom>
        Privacy Policy
      </Typography>
      <Hr />
      <Typography type="heading5" gutterTop gutterBottom>
        Our commitment to Privacy
      </Typography>
      <Typography type="body" gutterTop gutterBottom>
        Your privacy is very important to us. Part of our operation of this Web
        site involves the collection and use of information about you. This
        privacy policy explains what type of information we collect and what we
        do with that information to allow you to make choices about the way your
        information is collected and used. This privacy policy may change from
        time to time, so please check it often.
      </Typography>
      <Typography type="heading5" gutterTop gutterBottom>
        What Information Do We Collect?
      </Typography>
      <Typography type="body" gutterTop gutterBottom>
        In general, you can visit this Web site without identifying who you are
        or revealing any information about yourself. Information collected
        online can generally be categorized as anonymous or (364, identifiable.
        Anonymous information is information that cannot be connected to the
        identity of a specific individual. (364, identifiable information is
        information that specifically identifies a particular user, such as
        name, address, or phone number. An example of anonymous information is
        the fact that, while this Web site may record the number of visits to a
        particular page that occur in a given period of time, it does not
        necessarily tell us the names or other identifying information of every
        visitor. Many users of this Web site will choose not to provide any
        (364, identifiable information; therefore, those individuals are
        anonymous to us, and any data collected about their use of this Web site
        is anonymous information.
      </Typography>
      <Typography type="heading5" gutterTop gutterBottom>
        Automatic Anonymous Information
      </Typography>
      <Typography type="body" gutterTop gutterBottom>
        When you visit our site, we collect certain technical and routing
        information about your computer. For example, we log environmental
        variables such as browser type, operating system and CPU speed, and the
        Internet Protocol (IP) address of your originating Internet Service
        Provider, to try to bring you the best possible service. We also record
        search requests and results to try to ensure the accuracy and efficiency
        of our search engine. We use your IP address to track your use of the
        site, including pages visited and the time spent on each page. We
        collect this information and use it to measure the use of this Web site
        and to improve its content and performance. All of the information that
        is automatically submitted to us by your browser is considered anonymous
        information. To the extent we share such information with third parties,
        it is not traceable to any particular user and will not be used to
        contact you.
      </Typography>
      <Typography type="heading5" gutterTop gutterBottom>
        Cookies
      </Typography>
      <Typography type="body" gutterTop gutterBottom>
        This site uses “cookies.” Cookies are small data files, typically made
        up of a string of text and numbers, that assign you a unique identifier.
        This information enables your computer to have a “dialogue” with our
        site and permits us to administer our site more efficiently and to
        provide a more tailored and user-friendly service to you. You may set
        your browser to notify you when you receive a cookie or to prevent
        cookies from being sent; if you do so, this may limit the functionality
        we can provide you when you visit our site.
      </Typography>
      <Typography type="body" gutterTop gutterBottom>
        Third parties that link on this site may use cookies or collect other
        information when you go to their site. We do not control the collection
        or use of your information by these companies. You should contact these
        companies directly if you have any questions about their collection or
        use of information about you.
      </Typography>
      <Typography type="heading5" gutterTop gutterBottom>
        How Do We Use Information We Collect?
      </Typography>
      <Typography type="body" gutterTop gutterBottom>
        We collect identifiable information only for providing the services you
        request, generating statistical studies, conducting marketing research,
        improving products and services, sending you surveys, and notifying you
        of new products and any other changes to our site or services that may
        affect you. When you submit identifiable information to us, you
        understand that you are agreeing to allow us to access, store, and use
        that information for those purposes.
      </Typography>
      <Typography type="body" gutterTop gutterBottom>
        We will not sell or give any identifiable information to any third
        parties.
      </Typography>
      <Typography type="body" gutterTop gutterBottom>
        We may be required by law enforcement or judicial authorities to provide
        identifiable information to the appropriate governmental authorities. If
        requested by law enforcement or judicial authorities, we will provide
        this information on receipt of the appropriate documentation. We may
        also release information to law enforcement agencies or other third
        parties if we feel it is necessary to protect the safety and welfare of
        our personnel or to enforce our terms of use.
      </Typography>
      <Typography type="heading5" gutterTop gutterBottom>
        Opt-Out Policy
      </Typography>
      <Typography type="body" gutterTop gutterBottom>
        If at any time you do not wish to receive offers and e-mails from us, we
        ask that you tell us. You may remove your name from our mailing list by
        sending us an e-mail addressed to {email} and indicating in the subject
        line “No Offers or E-mail.”
      </Typography>
      <Typography type="heading5" gutterTop gutterBottom>
        Security
      </Typography>
      <Typography type="body" gutterTop gutterBottom>
        We operate secure data networks protected by industry standard firewall
        and password protection systems. Our security and privacy policies are
        periodically reviewed and enhanced as necessary, and only authorized
        individuals have access to the (364, identifiable information provided
        by our users. We do not, however, guarantee that unauthorized,
        inadvertent disclosure will never occur.
      </Typography>
      <Typography type="heading5" gutterTop gutterBottom>
        Transfer of Customer Information
      </Typography>
      <Typography type="body" gutterTop gutterBottom>
        Customer lists and information are properly considered assets of a
        business. Accordingly, if we merge with another entity or if we sell our
        assets to another entity, our customer lists and information, including
        identifiable information you have provided us, would be included among
        the assets that would be transferred.
      </Typography>
    </div>
  );
};

const styles = () => ({
  root: {
    position: "relative",
    width: "100%",
    maxWidth: "970px",
    margin: "40px auto",
    "& p": {
      maxWidth: "100%",
    },
  },
});

export default withGlobalContext(withStyles(styles)(Agentology));
